import React, { FC } from "react";

import Banner from "../../../components/Banner";
import { PaymentIssueMessage } from "../../../components/PaymentIssueMessage/PaymentIssueMessage";
import { PaymentBannerProps } from "./types";

export const PaymentBanner: FC<PaymentBannerProps> = ({
  isPhSubscription,
  isServiceActive,
}) => {
  // An overdue crypto renewal that is still being served is a deadline, not an
  // outage: the red error banner said "stopped" before a word was read, next to
  // a subscription card that (correctly) says the service continues until the
  // grace period ends. Warning matches the card's own `variant="warning"`.
  const isServedOverdue = !!isPhSubscription && !!isServiceActive;

  return (
    <Banner type={isServedOverdue ? "warning" : "error"}>
      <PaymentIssueMessage
        isPhSubscription={isPhSubscription}
        isServiceActive={isServiceActive}
      />
    </Banner>
  );
};
